import React, { useEffect, useState } from 'react';
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import { urlObtenerOpciones } from '../../constants/urls';





const SelectC = ({
  id,
  value,
  valueSelect,
  placeholder,
  onChange,
  mensajeError,
  isSearchable,
  peticiones,
  valorPadre,
  esDependiente,
  codPadre,
  validate,
  hasError,
  validationCallback,
  values,
  setLoading,
  isMulti,
  valorDependiente,
  required,
  esBloqueante,
  errorBloqueante,
  disabled,
  validacionYup,
  mensajeErrorYup
}) => {

  const [options, setOptions] = useState([])

  useEffect(() => {

    if (peticiones != null) {
      obtenerOpciones()
    }



  }, [])

  useEffect(() => {

    if (valueSelect) {

      const opcionSeleccionada = options.find(option => option.label == valueSelect)


      const opcionSeleccionadaSelect = Array.isArray(values) ? values.find(option => option.value == valueSelect.value) : null


      if (opcionSeleccionadaSelect) {
        onChange(opcionSeleccionadaSelect)
        validationCallback(false)
      }

      if (opcionSeleccionada) {
        onChange(opcionSeleccionada)
        validationCallback(false)
      }

      if (opcionSeleccionada && opcionSeleccionada.esBloqueante == 'NO') {
        onChange(opcionSeleccionada)
        validationCallback(false)
      }
    }




  }, [valueSelect])


  useEffect(() => {


    if (values) {
      setOptions(values)
    }

  }, [values])


  useEffect(() => {
    if (peticiones != null) {
      obtenerOpciones()
    }

    if (values) {
      setOptions(values)
    }

  }, [esDependiente && valorPadre])

  const obtenerOpciones = async () => {



    setLoading(true)


    let url = `${urlObtenerOpciones}${peticiones.url}`;

    console.log('verUrl', url)
    let body = peticiones.metodo == 'POST' ? JSON.stringify(peticiones.body) : null


    if (esDependiente) {
      if (peticiones.metodo == 'POST') {
        body = body.replace("$" + codPadre, valorPadre)
      }

      if (peticiones.metodo == 'GET') {
        if(codPadre && codPadre && valorPadre && valorPadre.value){
          url = url.replace("$" + codPadre, valorPadre.value)
        }
      
      }





    }


    try {
      const response = await fetch(url, { method: peticiones.metodo, body: body })
      const json = await response.json()
      if (json) {



        let aux = []
        const atributo = peticiones.atributo;

        // Dividir la cadena de atributo en partes usando el punto como separador
        const partes = atributo.split(".");

        // Inicializar una variable temporal para mantener el objeto JSON actual
        let objetoActual = json;

        // Iterar sobre las partes para acceder al valor anidado en el objeto JSON
        for (const parte of partes) {
          objetoActual = objetoActual[parte];

          // Verificar si el objeto actual es indefinido o nulo
          if (objetoActual === undefined || objetoActual === null) {
            break;
          }
        }

        // opciones contendrá el valor final obtenido del objeto JSON
        let opciones = objetoActual;
        //let opciones = json[peticiones.atributo]

        opciones.forEach(p => {
          aux.push({ ...p, value: p[peticiones.value], label: p[peticiones.label] });
        });
        setOptions(aux)

      }
    } catch (error) {
    }

    setLoading(false)
  }


  return (
    <div title={"select"}>



      {options.length > -1 &&
        <Select
          id={id}
          key={id}
          value={value}
          components={makeAnimated()}
          isDisabled={(!valorDependiente ? false : (valorDependiente != valorPadre)) || disabled}
          onChange={(valor, e) => {
            onChange(valor)

            if (valor.esBloqueante == 'SI') {
              validationCallback(true)
            } else if (isMulti && valor.length == 0) {
              validationCallback(true)
            } else {
              validationCallback(false)
            }




          }}
          options={options}
          isSearchable={isSearchable}
          placeholder={placeholder}
          isMulti={isMulti}
        />

      }



      {
        (!validacionYup && esBloqueante) ?

          <div class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">{errorBloqueante}</div> : null
      }
      {

        (!validacionYup && required && hasError && !esBloqueante) ?
          <div class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">{mensajeError}</div> : null
      }

      {validacionYup &&

        <label className='react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp'>
          {mensajeErrorYup}
        </label>
      }





    </div>
  );
};

export default SelectC;
